import { Injectable } from '@angular/core';

export enum SearchErrorMessage {
	NoPricesFound = 2,
	NoAdditionalDataFound = 3,
	ReduceDateRange = 101,
	ReduceIntervalOfNights = 102,
	ReduceDateRangeOrNumberOfNights = 105,
	NoToursMatchingFilterCriteria = 2101,
	TourNotFound = 2102,
	InvalidValueForFilterPromotion = 2103,
	InvalidValueForFilterProgramGroup = 2104,
	NoProgramsMatchFilterCriteria = 2105,
	InvalidValueForFilterCurrency = 2106,
	InvalidValueForFilterPower = 2107,
	InvalidValueForFilterNumber = 2108,
	InvalidValueForFilterCategory = 2109,
	NoHotelsMatchFilterCriteria = 2110,
	InvalidValueForFilterTourStartFrom = 2111,
	InvalidValueForFilterTourStartTo = 2112,
	InvalidValueForFiltersTourStart = 2113,
	InvalidValueForFiltersDuration = 2114,
}

export class SearchErrorMessageService {
	private static readonly messages: Record<SearchErrorMessage, string> = {
		[SearchErrorMessage.NoPricesFound]: 'searchResult.errorMessage.noPricesFound',
		[SearchErrorMessage.NoAdditionalDataFound]: 'searchResult.errorMessage.noAdditionalDataFound',
		[SearchErrorMessage.ReduceDateRange]: 'searchResult.errorMessage.reduceDateRange',
		[SearchErrorMessage.ReduceIntervalOfNights]: 'searchResult.errorMessage.reduceIntervalOfNights',
		[SearchErrorMessage.ReduceDateRangeOrNumberOfNights]:
			'searchResult.errorMessage.reduceDateRangeOrNumberOfNights',
		[SearchErrorMessage.NoToursMatchingFilterCriteria]: 'searchResult.errorMessage.noToursMatchingFilterCriteria',
		[SearchErrorMessage.TourNotFound]: 'searchResult.errorMessage.tourNotFound',
		[SearchErrorMessage.InvalidValueForFilterPromotion]: 'searchResult.errorMessage.invalidValueForFilterPromotion',
		[SearchErrorMessage.InvalidValueForFilterProgramGroup]:
			'searchResult.errorMessage.invalidValueForFilterProgramGroup',
		[SearchErrorMessage.NoProgramsMatchFilterCriteria]: 'searchResult.errorMessage.noProgramsMatchFilterCriteria',
		[SearchErrorMessage.InvalidValueForFilterCurrency]: 'searchResult.errorMessage.invalidValueForFilterCurrency',
		[SearchErrorMessage.InvalidValueForFilterPower]: 'searchResult.errorMessage.invalidValueForFilterPower',
		[SearchErrorMessage.InvalidValueForFilterNumber]: 'searchResult.errorMessage.invalidValueForFilterNumber',
		[SearchErrorMessage.InvalidValueForFilterCategory]: 'searchResult.errorMessage.invalidValueForFilterCategory',
		[SearchErrorMessage.NoHotelsMatchFilterCriteria]: 'searchResult.errorMessage.noHotelsMatchFilterCriteria',
		[SearchErrorMessage.InvalidValueForFilterTourStartFrom]:
			'searchResult.errorMessage.invalidValueForFilterTourStartFrom',
		[SearchErrorMessage.InvalidValueForFilterTourStartTo]:
			'searchResult.errorMessage.invalidValueForFilterTourStartTo',
		[SearchErrorMessage.InvalidValueForFiltersTourStart]:
			'searchResult.errorMessage.invalidValueForFiltersTourStart',
		[SearchErrorMessage.InvalidValueForFiltersDuration]: 'searchResult.errorMessage.invalidValueForFiltersDuration',
	};

	public static getMessage(errorCode: SearchErrorMessage): string {
		return this.messages[errorCode] || 'Unknown error occurred.';
	}
}
